/**************************************************************************************************/
/** @import Helpers/Documents                                                                    **/
/**************************************************************************************************/
import { PDFRoundedRectangle } from '@/Helpers/Documents/LegacyPDF/GeometryPDF'
import { LegacyPDF } from '@/Helpers/Documents/LegacyPDF/LegacyPDF'
import { TablePDF } from '@/Helpers/Documents/LegacyPDF/TablePDF'

/**************************************************************************************************/
/** @export Class @name UtilsPDF                                                                 **/
/**************************************************************************************************/
export class UtilsPDF
{
	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public addSubHeader(pdf: LegacyPDF, text: string, includeHeight = true) : this
	{
		new PDFRoundedRectangle(pdf, -pdf.getPageMargin(), 24, 156, 32, 32, [0, 1, 1, 0], '#FF8225').setIncludeHeight(false).draw()
		pdf.setFontColor('#4C78B3').setFontSize(24)
		pdf.addTextCentered(text, 4, 0, includeHeight)
		return this
	}

	public addSubHeaderAndInfoToRight(pdf: LegacyPDF, text: string, ...textLines: Array<string>) : this
	{
		this.addSubHeader(pdf, text, false)
		pdf.setFontColor('#333')
		let linesSumY = 0

		for (let i = 0; i < textLines.length; i++)
		{
			const lineY = 14 * i
			pdf.addTextRight(textLines[i], 0, lineY, 10, false)
			linesSumY += lineY
		}
		pdf.updateGlobalY(linesSumY)
		return this
	}

	public addTableFooter(pdfTable: TablePDF, extraY: number, text: string) : this
	{
		const extraOffsetY = pdfTable.getPDF().getNumPages() > 2 ? extraY : 0
		pdfTable.setFooterY(extraOffsetY).drawFooter(pdfTable.getPDF(), text)
		return this
	}

	public addTableClientInformation(pdf: LegacyPDF, client: string, storage: string) : this
	{
		const generalInfoRowsTable1 =
		[
			{ col: 'Cliente:', val: client },
			{ col: 'Ubicación:', val: storage }
		]
		new TablePDF(pdf, 0, 8, this.GetGeneralInfoColumns(), generalInfoRowsTable1)
			.setActiveColId('col').colFontStyle('bold').colTextColor('#FD921A')
			.setTheme('grid')
			.setUpdateGlobalY(false)
			.setWidth(pdf.getPageWidth() / 2)
			.showHeader(false)
			.draw()
		;
		return this
	}

	public addTableDateResponsibleInformation(pdf: LegacyPDF, date: string, responsible: string) : this
	{
		const generalInfoRowsTable2 =
		[
			{ col: 'Fecha Informe:', val: date },
			{ col: 'Responsable:', val: `${ responsible }` }
		]
		new TablePDF(pdf, pdf.getPageWidth() / 2, 8, this.GetGeneralInfoColumns(), generalInfoRowsTable2)
			.setActiveColId('col').colFontStyle('bold').colTextColor('#FD921A')
			.setTheme('grid')
			.setWidth(pdf.getPageWidth() / 2)
			.showHeader(false)
			.draw()
		;
		return this
	}

	private GetGeneralInfoColumns() : Array<{ key: string, label: string }>
	{
		return [
			{ key: 'col', label: 'KEY' },
			{ key: 'val', label: 'VALUE' }
		]
	}
}